import React from 'react';
import PropTypes from 'prop-types';

import styles from './DomainLabel.scss';

const DomainLabel = ({text, mode}) => {
	return (
		<span className={`${styles.label} ${styles[mode]}`}>{text}</span>
	)
};
DomainLabel.propTypes = {
	text: PropTypes.string.isRequired,
	mode: PropTypes.string.isRequired,
};
export default DomainLabel;